var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"id":"app"}},[_c('Header'),_c('Editor',{on:{"selectedPeriodChange":_vm.selectedPeriodChange}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }